import { Component } from '@angular/core';
//import { IonicPage, NavController, NavParams,LoadingController, Loading} from 'ionic-angular';

import { NavController,Loading,LoadingController } from 'ionic-angular';
 import { AuthService } from '../../providers/auth';
// import { TabsPage } from '../../pages/tabs/tabs';
// import { SigupPage } from '../../pages/sigup/sigup';
import { HomePage } from '../../pages/home/home';
// import { VerifyemailPage} from '../../pages/verifyemail/verifyemail';


// import { MobilevarificationPage } from '../../pages/mobilevarification/mobilevarification';
//import { Http , RequestOptions , Headers} from '@angular/http';
/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
loading: Loading;
 obj:any;
//  //tab:Tabs;

//login={"Username":'',"password":'',"company_id":''};
login={"Loginid":'',"company_id":''};          // ismail


constructor(public loadingCtrl: LoadingController,public navCtrl: NavController,public authService:AuthService) {

}

  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');

  }
  // movetohomepage(){
  //   this.navCtrl.setRoot(HomePage);
  // }

    movetohomepage(){
      this.loading = this.loadingCtrl.create({
        content: '',
        });
          this.loading.present();
     // this.navCtrl.push(TabsPage);
      this.login.Loginid = this.login.Loginid;
      //this.login.Username = this.login.Username;
      //this.login.password = this.login.password;
      this.login.company_id = this.login.company_id;

      let data_parameters= this.login;
      let method='customerlogin.php';
      let temp={};
      // this.loading = this.loadingCtrl.create({
      // content: '',
      // });

      //  this.loading.present();
     //  console.log(data_parameters);
       this.authService.postData(data_parameters,method).then((result) => {
       // this.loading.present();
       this.obj = result;
       console.log(this.obj);
       
      if(this.obj.status=='true'){
      //this.loading.dismissAll();
      this.loading.dismiss();
     localStorage.setItem("name",this.obj.name);
     localStorage.setItem("customers_id",this.obj.customers_id);
     localStorage.setItem("company_id",this.obj.company_id);
     localStorage.setItem("Loginid",this.obj.Loginid);
     //localStorage.setItem("name",this.obj.name);

     
      this.navCtrl.setRoot(HomePage);
       }
      
      else{
        this.loading.dismiss();
       alert(this.obj.message);
       }
       
       }, (err) => {
         // Error log
     });


   }

  //  signuppagemove(){
  //  this.navCtrl.push(SigupPage);
  //  }

  //  mobilvaripagemove(){
  //  this.navCtrl.push(MobilevarificationPage);
  //  }

  


    
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts